<div class="p-grid">
    <div class="p-col-12">

        <p-toast></p-toast>

        <div class="card">
            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="{{ 'label.novo' | translate }}" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2" (click)="openNew()" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                </ng-template>

                <ng-template pTemplate="right">
                    <button pButton pRipple label="{{ 'label.exportar' | translate }}" icon="pi pi-upload" class="p-button-help p-mb-2" (click)="downloadFile()"></button>
                </ng-template>
            </p-toolbar>

            <p-table #dt [value]="empresas" [columns]="cols" [rows]="10" [paginator]="true" 
                [globalFilterFields]="['nmeEmpresa','nroCNPJ','dscEndereco','nroTelefone','nroCNPJ','staAplicao']"
                     [(selection)]="selectedEmpresas" [rowHover]="true" dataKey="id"
                     styleClass="p-datatable-customers"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <h5 class="p-m-0">{{ 'empresa.titulo' | translate }}</h5>
                        <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                    </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nmeEmpresa">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'empresa.nome' | translate }}
                                <p-sortIcon field="nmeEmpresa"></p-sortIcon>
                                <p-columnFilter type="text" field="nmeEmpresa" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nroCNPJ">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'empresa.cnpj' | translate }}
                                <p-sortIcon field="nroCNPJ"></p-sortIcon>
                                <p-columnFilter type="text" field="nroCNPJ" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="dscEndereco">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'empresa.endereco' | translate }}
                                <p-sortIcon field="dscEndereco"></p-sortIcon>
                                <p-columnFilter type="text" field="dscEndereco" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="dscEmail" style="width: 200px;">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'empresa.email' | translate }}
                                <p-sortIcon field="dscEmail"></p-sortIcon>
                                <p-columnFilter type="text" field="dscEmail" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nroTelefone">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'empresa.telefone' | translate }}
                                <p-sortIcon field="nroTelefone"></p-sortIcon>
                                <p-columnFilter type="text" field="nroTelefone" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="staEmpresa">{{ 'label.situacao' | translate }}<p-sortIcon field="staAplicao"></p-sortIcon></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-empresa>
                    <tr>
                                                                         
                        <td><span class="p-column-title" style="text-align: center;">Nome Empresa</span>
                            {{empresa.nmeEmpresa}}
                        </td>
                        <td>{{formatarDocumento(empresa.nroCNPJ)}}</td>
                        <td><span class="p-column-title" style="text-align: center;">Codigo Aplicacao</span>
                            {{empresa.dscEndereco}}
                        </td>
                        <td><span class="p-column-title" style="text-align: center;">Descricao Aplicacao</span>
                            {{empresa.dscEmail}}</td>
                        <td><span class="p-column-title" style="text-align: center;">Nome Aplicacao</span>
                            {{formata_telefone(empresa.nroTelefone)}}
                         </td>
                        <td><span class="p-column-title" style="text-align: center;">Nome Aplicacao</span>
                            {{empresa.staEmpresa}}
                        </td>
                        <td>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2" (click)="editEmpresa(empresa)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>

                            <button pButton pRipple icon="pi pi-check-circle" class="p-button-rounded p-button-success" (click)="deleteEmpresa(empresa)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT' && empresa.staEmpresa == 'Ativo'"></button>

                            <button pButton pRipple icon="pi pi-check-circle" class="p-button-rounded p-button-error" (click)="deleteEmpresa(empresa)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT' && empresa.staEmpresa == 'Inativo'"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                       {{ 'label.totalde' | translate }} {{empresas ? empresas.length : 0 }} {{ 'empresa.empresas' | translate }}.
                    </div>
                </ng-template>
            </p-table>
        </div>

        <p-dialog [(visible)]="empresaDialog" [style]="{width: '450px'}" header="{{ 'empresa.detalhes' | translate }}" [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                    <label for="name">{{ 'empresa.nome' | translate }}</label>
                    <input type="text" pInputText id="codEmpresa" [(ngModel)]="empresa.nmeEmpresa" required autofocus />
                    <small class="p-invalid" *ngIf="submitted && !empresa.nmeEmpresa">Codigo Empresa obrigatorio.</small>
                                                    </div>
                                                    <div class="p-field">
                    <label for="name">{{ 'empresa.inscricaoestadual' | translate }}</label>
                    <input type="text" pInputText id="name" [(ngModel)]="empresa.nroInscricaoEstadual" required autofocus />
                    <small class="p-invalid" *ngIf="submitted && !empresa.nroInscricaoEstadual">Nome do do perfil obrigatorio.</small>
                                                    </div>
                                                    <div class="p-field">
                    <label for="name">{{ 'empresa.cnpj' | translate }}</label>
                    <input type="text" pInputText id="name" [(ngModel)]="empresa.nroCNPJ" required autofocus />
                    <small class="p-invalid" *ngIf="submitted && !empresa.nroCNPJ">Nome do do perfil obrigatorio.</small>
                </div>
                <div class="p-field">
                    <label for="name">{{ 'empresa.endereco' | translate }}</label>
                    <input type="text" pInputText id="name" [(ngModel)]="empresa.dscEndereco" required autofocus />
                    <small class="p-invalid" *ngIf="submitted && !empresa.nmeEmpresa">Nome do do perfil obrigatorio.</small>
                </div>
                <div class="p-field">
                    <label for="name">{{ 'empresa.uf' | translate }}</label>
                    <span class="p-float-label" >
                        <p-dropdown inputId="estados" [options]="estados" [(ngModel)]="empresa.estado" optionValue="uf" optionLabel="nome" [autoDisplayFirst]="false"></p-dropdown>
                    </span>
                </div>

               <div class="p-field">                    
               		<label for="name">{{ 'empresa.cep' | translate }}</label>
                    <input type="text" pInputText id="name" [(ngModel)]="empresa.nroCep" required autofocus maxlength="9"/>
                    <small class="p-invalid" *ngIf="submitted && !empresa.nroCep">Nome do do perfil obrigatorio.</small>
                                                    </div>
                                                    <div class="p-field">
                    <label for="name">{{ 'empresa.email' | translate }}</label>
                    <input type="text" pInputText id="name" [(ngModel)]="empresa.dscEmail" required autofocus />
                    <small class="p-invalid" *ngIf="submitted && !empresa.dscEmail">Nome do do perfil obrigatorio.</small>
                                                    </div>
                                                    <div class="p-field">
                    <label for="name">{{ 'empresa.telefone' | translate }}</label>
                    <input type="text" pInputText id="name" [(ngModel)]="empresa.nroTelefone" required autofocus maxlength="16"/>
                    <small class="p-invalid" *ngIf="submitted && !empresa.nroTelefone">Nome do do perfil obrigatorio.</small>
                                                    </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
                <button pButton pRipple label="{{ 'label.salvar' | translate }}" icon="pi pi-check" class="p-button-text" (click)="saveEmpresa()"></button>
            </ng-template>
        </p-dialog>

        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    </div>
</div>
